import {Component, Input, OnInit} from '@angular/core';
import {MenuSelectionItem} from 'brewbill-lib';

@Component({
    selector: 'bb-edit-menu-selection-item',
    templateUrl: './edit-menu-selection-item.component.html',
    styleUrls: ['./edit-menu-selection-item.component.scss'],
})
export class EditMenuSelectionItemComponent implements OnInit {
    @Input() menuSelectionItem: MenuSelectionItem;

    constructor() {
    }

    ngOnInit() {
    }
}
